module.exports = __webpack_public_path__ + "static/media/default-overlay.fd936007.png";